import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { devConfig, profile, urlJs, urlJs2, walletcode } from 'config/config'; // Importing configuration variables

export default class betHistoryView extends JetView {
    // Defining the betHistoryView class extending JetView
    config() {
        // Method to configure the view
        var lng = 'es-ES'; // Default language set to Spanish
        if (this.app.getService('locale').getLang() == 'en') {
            // Check if the current language is English
            lng = 'en'; // Set language to English
        } else {
            lng = 'es-ES'; // Default to Spanish if not English
        }
        var skinIdITN; // Variable to hold skin ID
        if (
            profile.skinIdITN == undefined || // Check if skinIdITN is undefined
            profile.skinIdITN == undefined || // Duplicate check (should be profile.skinIdITN)
            profile.skinIdITN == null // Check if skinIdITN is null
        ) {
            skinIdITN = 'doradobet'; // Set default skin ID
        } else {
            skinIdITN = profile.skinIdITN; // Use the skin ID from profile
        }
        webix.require([urlJs], function () {
            // Require external JavaScript file
            (function () {
                // Immediately Invoked Function Expression (IIFE)
                var AltenarSportsbook2 = function (_containerId, _initParams) {
                    // Constructor for AltenarSportsbook2
                    _initParams = _initParams || {}; // Initialize _initParams if not provided
                    var checkAndCallPlatformCallback = function (_callbackName, _param) {
                        // Function to check and call platform callbacks
                        var hasCallback = false; // Flag to check if callback exists
                        if (typeof _initParams[_callbackName] === 'function') {
                            // Check if callback is a function
                            _initParams[_callbackName](_param); // Call the callback with parameters
                            hasCallback = true; // Set flag to true
                        }
                        return hasCallback; // Return the callback existence status
                    };
                    if (
                        (window.location.search || '') // Check if URL contains cookie policy error
                            .toLowerCase()
                            .indexOf('error=cookiepolicy') > -1
                    ) {
                        console.log('Cookies are disabled'); // Log message for disabled cookies
                        checkAndCallPlatformCallback('cookieserrorcallback', {}); // Call cookies error callback
                        return {}; // Return empty object
                    }
                    var buildVersion = 'currentBuildVersion'; // Variable for build version
                    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent); // Check if the browser is Safari
                    var triggerStateChangeCallback = true; // Flag for state change callback
                    var extendInitParamsWithSRC = function (_string) {
                        // Function to extend init parameters with source
                        var pairs =
                            ((((_string || '').split('?') || [])[1] || '').split('#') || []).join('&').split('&') || []; // Parse query string into key-value pairs
                        for (var i = 0; i < pairs.length; i++) {
                            // Iterate through pairs
                            var pair = pairs[i].split('='); // Split pair into key and value
                            _initParams[pair[0]] = pair[1] || null; // Assign value to initParams
                        }
                    };
                    var iframe = document.createElement('iframe'); // Create an iframe element
                    var scripts = document.querySelectorAll('script'); // Select all script elements
                    var defaultIframeUrl; // Variable to hold default iframe URL
                    for (var i = 0; i < scripts.length; i++) {
                        // Iterate through scripts
                        var scriptSrc = scripts[i].src || ''; // Get script source
                        if (scriptSrc.toLowerCase().indexOf('altenarsportsbook') > -1) {
                            // Check if script source contains 'altenarsportsbook'
                            var splittedUrl = scriptSrc.toLowerCase().split('/'); // Split URL into parts
                            var rootIndex = splittedUrl.indexOf('static'); // Find index of 'static'
                            splittedUrl.length = rootIndex; // Trim the array to the root index
                            defaultIframeUrl = splittedUrl.join('/'); // Join parts to form default URL
                        }
                    }
                    var postIFrameMessage = function (method, params) {
                        // Function to post messages to iframe
                        iframe &&
                            iframe.contentWindow &&
                            iframe.contentWindow.postMessage(
                                { method: method, params: params }, // Post message with method and parameters
                                _initParams.url || defaultIframeUrl, // Target URL for the message
                            );
                    };
                    var postloadParams = {
                        // Object to hold post-load parameters
                        params: ['betslipoddids', 'betreservationcode', 'betid', 'banners'],
                        getParams: function () {
                            // Method to get parameters
                            var resultParams = {}; // Object to hold result parameters
                            for (var idx = 0; idx < this.params.length; idx++) {
                                // Iterate through params
                                var paramName = this.params[idx]; // Get parameter name
                                resultParams[paramName] = _initParams[paramName]; // Assign value from initParams
                            }
                            return resultParams; // Return result parameters
                        },
                        sendIFrameMessage: function () {
                            // Method to send message to iframe
                            var params = this.getParams(); // Get parameters
                            postIFrameMessage('postLoad', params); // Post message with parameters
                        },
                        hasParam: function (_value) {
                            // Method to check if a parameter exists
                            return this.params.indexOf(_value) > -1; // Return boolean
                        },
                    };
                    var dimensionsParams = {
                        // Object to hold dimensions parameters
                        params: ['fixedtop', 'fixedbottom'], // List of dimension parameters
                        getParams: function () {
                            // Method to get dimension parameters
                            var resultParams = {}; // Object to hold result parameters
                            var iframeRect = iframe.getBoundingClientRect(); // Get iframe dimensions
                            var iframeBottom = iframeRect.bottom; // Get bottom position
                            var iframeTop = iframeRect.top; // Get top position
                            for (var idx = 0; idx < this.params.length; idx++) {
                                // Iterate through dimension params
                                var paramName = this.params[idx]; // Get parameter name
                                var platformIndent = parseFloat(_initParams[paramName]) || 0; // Get platform indent
                                var paramValue = 0; // Initialize parameter value
                                switch (
                                    paramName // Switch based on parameter name
                                ) {
                                    case 'fixedtop':
                                        if (platformIndent > iframeTop) {
                                            // Check if platform indent is greater than iframe top
                                            paramValue = platformIndent - iframeTop; // Calculate parameter value
                                        }
                                        break;
                                    case 'fixedbottom':
                                        if (
                                            platformIndent >
                                            window.innerHeight - iframeBottom // Check if platform indent is greater than iframe bottom
                                        ) {
                                            paramValue = iframeBottom - window.innerHeight + platformIndent; // Calculate parameter value
                                        }
                                        break;
                                }
                                resultParams[paramName] = paramValue; // Assign calculated value to result parameters
                            }
                            resultParams['innerHeight'] = window.innerHeight; // Add inner height to result parameters
                            return resultParams; // Return result parameters
                        },
                        sendIFrameMessage: function () {
                            // Method to send message to iframe
                            var params = {};
                            if (!_initParams.isfixed) {
                                // Check if not fixed
                                params = this.getParams(); // Get parameters
                            }
                            postIFrameMessage('changeDimensions', params); // Post message with dimensions
                        },
                        hasParam: function (_value) {
                            // Method to check if a parameter exists
                            return this.params.indexOf(_value) > -1; // Return boolean
                        },
                    };
                    var queryParams = {
                        // Object to hold query parameters
                        params: [
                            'token',
                            'accesstoken',
                            'skinid',
                            'walletcode',
                            'lang',
                            'configid',
                            'ishybridmode',
                            'isfixed',
                            'fixedtop',
                            'fixedbottom',
                            'staticorigin',
                            'instance',
                            'betslipoddids',
                            'betreservationcode',
                            'timezoneoffset',
                            'numformat',
                            'hasplacebetplatformerrorcallback',
                            'oddstype',
                            'special',
                            'virtualsports',
                            'ishashclassesmode',
                            'betreuseurltemplate',
                            'authrefreshtimeout',
                        ],
                        getQueryParams: function () {
                            // Method to get query parameters
                            var stringQuery = 'origin=' + defaultIframeUrl + '/static/'; // Initialize query string
                            for (var paramName of Object.keys(_initParams)) {
                                // Iterate through initParams
                                if (this.params.indexOf(paramName) > -1) {
                                    // Check if param exists
                                    var isNull = _initParams[paramName] === null; // Check if value is null
                                    var isUndefined = _initParams[paramName] === undefined; // Check if value is undefined
                                    if (!isNull && !isUndefined) {
                                        // If value is neither null nor undefined
                                        if (stringQuery !== '') {
                                            // If query string is not empty
                                            stringQuery += '&'; // Append '&' to query string
                                        }
                                        stringQuery += paramName + '=' + encodeURIComponent(_initParams[paramName]); // Append parameter to query string
                                    }
                                }
                            }
                            stringQuery = stringQuery !== '' ? '?' + stringQuery : stringQuery; // Format query string
                            if (isSafari) {
                                // If the browser is Safari
                                stringQuery += '&r=' + new Date().toLocaleString(); // Append timestamp to query string
                            }
                            stringQuery +=
                                '&hasplacebetplatformerrorcallback=' +
                                (typeof _initParams['placebetplatformerrorcallback'] === 'function'); // Append callback existence to query string
                            return stringQuery; // Return formatted query string
                        },
                    };
                    var hashParams = {
                        // Object to hold hash parameters
                        params: ['page', 'eventid', 'sportids', 'catids', 'champids', 'betid', 'betreuseid'],
                        getHashParams: function () {
                            // Method to get hash parameters
                            var hash = '#/'; // Initialize hash
                            var pageName = (_initParams[this.params[0]] || 'prelive').toLowerCase(); // Get page name
                            var isSportContent = pageName === 'prelive' || pageName === 'live'; // Check if content is sport-related
                            var eventDetails = this.getEventDetailsHash(); // Get event details hash
                            if (isSportContent && eventDetails) {
                                // If sport content and event details exist
                                hash += eventDetails; // Append event details to hash
                            } else if (_initParams['betreuseid']) {
                                // Check if bet reuse ID exists
                                hash = '#/' + 'betReuse' + '/' + _initParams['betreuseid'] + '/isSinglePage'; // Format hash for bet reuse
                            } else {
                                var eventsGroupsHash = this.getEventsGroupsHash(); // Get events groups hash
                                hash += pageName; // Append page name to hash
                                var mybets = pageName === 'mybets'; // Check if page is 'mybets'
                                if (mybets && _initParams.betid) {
                                    // If on 'mybets' page and bet ID exists
                                    hash = '#/' + 'mybets' + '/' + _initParams.betid; // Format hash for my bets
                                } else if (eventsGroupsHash) {
                                    // If events groups hash exists
                                    if (
                                        pageName === 'prelive' &&
                                        !this.isOnlySport() // Check if page is prelive and not only sport
                                    ) {
                                        hash = '#/tree/all/' + eventsGroupsHash + 'odds'; // Format hash for odds
                                    } else if (pageName === 'competitions') {
                                        // If on competitions page
                                        hash = '#/' + eventsGroupsHash + '/competitions/all'; // Format hash for competitions
                                    } else if (pageName === 'coupons') {
                                        // If on coupons page
                                        hash = '#/' + eventsGroupsHash + '/coupons'; // Format hash for coupons
                                    } else if (isSportContent) {
                                        // If sport content
                                        hash += '/' + eventsGroupsHash; // Append events groups hash
                                    } else {
                                        hash += '/'; // Default case
                                    }
                                }
                            }
                            var lastSymbol = hash[hash.length - 1]; // Get last character of hash
                            if (lastSymbol === '/') {
                                // If last character is '/'
                                hash = hash.slice(0, hash.length - 1); // Remove last character
                            }
                            return hash; // Return formatted hash
                        },
                        getPageNameHash: function () {
                            // Method to get page name hash
                            var hash = ''; // Initialize hash
                            var hashParams = this; // Reference to hashParams
                            var pageName = _initParams[this.params[0]] || 'prelive'; // Get page name
                            switch (
                                pageName // Switch based on page name
                            ) {
                                case 'prelive':
                                    hash += 'prelive/' + hashParams.getEventsGroupsHash(); // Append prelive and events groups hash
                                    break;
                                case 'live':
                                    hash += 'live/' + hashParams.getEventsGroupsHash(); // Append live and events groups hash
                                    break;
                                default:
                                    hash += pageName; // Default case
                                    break;
                            }
                            return hash; // Return formatted hash
                        },
                        getEventDetailsHash: function () {
                            // Method to get event details hash
                            var eventId = _initParams[this.params[1]]; // Get event ID
                            var pageName = _initParams[this.params[0]]; // Get page name
                            if (eventId) {
                                // If event ID exists
                                var hash; // Initialize hash
                                var sportIds = _initParams.sportids || '0'; // Get sport IDs
                                var catIds = _initParams.catids || '0'; // Get category IDs
                                var champIds = _initParams.champids || '0'; // Get championship IDs
                                if (pageName === 'live') {
                                    // If on live page
                                    hash = 'live/event/' + sportIds + '/'; // Format hash for live event
                                } else {
                                    hash = 'event/' + sportIds + '/' + catIds + '/' + champIds + '/all/'; // Format hash for event
                                }
                                hash += eventId + '/'; // Append event ID to hash
                                return hash; // Return formatted hash
                            } else {
                                return false; // Return false if no event ID
                            }
                        },
                        isOnlySport: function () {
                            // Method to check if only sport is selected
                            var onlySport; // Initialize flag
                            onlySport = _initParams.sportids && !(_initParams.catids || _initParams.champids); // Check if only sport is selected
                            return onlySport; // Return boolean
                        },
                        getEventsGroupsHash: function (_forCompetitions) {
                            // Method to get events groups hash
                            var hash = ''; // Initialize hash
                            var params = this.params; // Reference to params
                            var isEventGroupNotEmpty = false; // Flag for event group status
                            if (this.isOnlySport() && !_forCompetitions) {
                                // If only sport is selected and not for competitions
                                return 'sport/' + _initParams.sportids; // Return sport hash
                            }
                            for (var i = 2; i <= 4; i++) {
                                // Iterate through categories
                                hash += addCatHash(i); // Append category hash
                            }
                            return isEventGroupNotEmpty ? hash : ''; // Return hash if not empty
                            function addCatHash(_index) {
                                // Function to add category hash
                                var sportsCategory = _initParams[params[_index]]; // Get sports category
                                if (sportsCategory) {
                                    // If category exists
                                    isEventGroupNotEmpty = true; // Set flag to true
                                    return sportsCategory + '/'; // Return category hash
                                } else {
                                    return '0/'; // Return default category hash
                                }
                            }
                        },
                    };
                    var setIframeSrc = function () {
                        // Function to set iframe source
                        var url = _initParams.url || defaultIframeUrl; // Get URL
                        var query = queryParams.getQueryParams(); // Get query parameters
                        var hash = hashParams.getHashParams(); // Get hash parameters
                        iframe.src = url + query + hash; // Set iframe source
                    };
                    var onWindowScroll = function (_event) {
                        // Event handler for window scroll
                        dimensionsParams.sendIFrameMessage(); // Send dimensions message to iframe
                    };
                    var onWindowResize = function (_event) {
                        // Event handler for window resize
                        dimensionsParams.sendIFrameMessage(); // Send dimensions message to iframe
                    };
                    var onIframeMessage = function (_event) {
                        // Event handler for messages from iframe
                        var data = _event.data || {}; // Get message data
                        switch (
                            data.type // Switch based on message type
                        ) {
                            case 'scroll':
                                if (
                                    window.scrollY > container.offsetTop && // Check if scrolled past container
                                    !_initParams.isfixed && // Check if not fixed
                                    !checkAndCallPlatformCallback('scrollcallback', {
                                        x: data.scroll.x,
                                        y: data.scroll.y + container.offsetTop,
                                    }) // Call scroll callback
                                ) {
                                    window.scrollTo(
                                        data.scroll.x,
                                        data.scroll.y + container.offsetTop, // Scroll to position
                                    );
                                }
                                break;
                            case 'resize':
                                if (
                                    !_initParams.isfixed && // Check if not fixed
                                    !checkAndCallPlatformCallback(
                                        'resizecallback',
                                        data.rect, // Call resize callback
                                    )
                                ) {
                                    iframe.height = data.rect && data.rect.height; // Set iframe height
                                }
                                dimensionsParams.sendIFrameMessage(); // Send dimensions message to iframe
                                break;
                            case 'load':
                                dimensionsParams.sendIFrameMessage(); // Send dimensions message to iframe
                                checkAndCallPlatformCallback(
                                    'loadcallback',
                                    data.hash, // Call load callback
                                );
                                setParam('banners', _initParams.banners); // Set banners parameter
                                break;
                            case 'refreshcookies':
                                if (
                                    (window.location.search || '') // Check if URL contains retry cookie policy
                                        .toLowerCase()
                                        .indexOf('retry=cookiepolicy') > -1
                                ) {
                                    console.log(
                                        'Third party cookies are disabled', // Log message for disabled cookies
                                    );
                                    checkAndCallPlatformCallback('cookieserrorcallback', {}); // Call cookies error callback
                                    destroy(); // Destroy instance
                                    return; // Exit function
                                }
                                if (!checkAndCallPlatformCallback('refreshcookiescallback', {})) {
                                    window.location.href =
                                        defaultIframeUrl +
                                        '/home/init?url=' +
                                        encodeURIComponent(
                                            window.location.origin + window.location.pathname + window.location.search,
                                        ); // Redirect to home with URL
                                }
                                break;
                            case 'hashchange':
                                checkAndCallPlatformCallback(
                                    'hashchangecallback',
                                    data.hash, // Call hash change callback
                                );
                                break;
                            case 'statechange':
                                if (triggerStateChangeCallback) {
                                    // Check if state change callback should be triggered
                                    checkAndCallPlatformCallback(
                                        'statechangecallback',
                                        data.params, // Call state change callback
                                    );
                                } else {
                                    triggerStateChangeCallback = true; // Reset flag
                                }
                                break;
                            case 'redirecttolive':
                                checkAndCallPlatformCallback(
                                    'redirecttolivecallback',
                                    data.eventId, // Call redirect to live callback
                                );
                                break;
                            case 'redirecttoprelive':
                                checkAndCallPlatformCallback(
                                    'redirecttoprelivecallback',
                                    data.eventId, // Call redirect to prelive callback
                                );
                                break;
                            case 'insufficientbalance':
                                checkAndCallPlatformCallback(
                                    'insufficientbalancecallback',
                                    data.totalStake, // Call insufficient balance callback
                                );
                                break;
                            case 'showeventdetails':
                                checkAndCallPlatformCallback(
                                    'showeventdetailscallback',
                                    data.eventId, // Call show event details callback
                                );
                                break;
                            case 'showevents':
                                checkAndCallPlatformCallback(
                                    'showeventscallback',
                                    data.events, // Call show events callback
                                );
                                break;
                            case 'showloginbox':
                                checkAndCallPlatformCallback(
                                    'showloginboxcallback', // Call show login box callback
                                );
                                break;
                            case 'betslipoddscountchange':
                                checkAndCallPlatformCallback(
                                    'betslipoddscountchangecallback',
                                    data.selectionIds, // Call bet slip odds count change callback
                                );
                                break;
                            case 'sportsmenu':
                                checkAndCallPlatformCallback(
                                    'sportsmenucallback',
                                    data.sports, // Call sports menu callback
                                );
                                break;
                            case 'placebet':
                                checkAndCallPlatformCallback(
                                    'placebetcallback',
                                    data.placeBet, // Call place bet callback
                                );
                                break;
                            case 'accesstoken':
                                _initParams.accesstoken = data.accesstoken; // Set access token
                                break;
                            case 'logoff':
                                if (
                                    !checkAndCallPlatformCallback(
                                        'logoffcallback', // Call logoff callback
                                    )
                                ) {
                                    window.location.reload(); // Reload the page
                                }
                                break;
                            case 'placebetplatformerror':
                                checkAndCallPlatformCallback(
                                    'placebetplatformerrorcallback',
                                    data.CallbackParameter, // Call place bet platform error callback
                                );
                                break;
                            case 'betReservation':
                                checkAndCallPlatformCallback(
                                    'betreservationcallback',
                                    data.reservationCode, // Call bet reservation callback
                                );
                                break;
                            case 'promobet':
                                checkAndCallPlatformCallback(
                                    'promobetcallback',
                                    data.promoBet, // Call promo bet callback
                                );
                                break;
                            case 'getEventDetailsAdditionalInfo':
                                checkAndCallPlatformCallback(
                                    'geteventdetailsadditionalinfocallback',
                                    data.externalInfo, // Call get event details additional info callback
                                );
                        }
                    };
                    var prepareInitParams = function () {
                        // Function to prepare initialization parameters
                        convertInitParamsToLowercase(); // Convert init parameters to lowercase
                        convertInitParamsToStrings(); // Convert init parameters to strings
                    };
                    var convertInitParamsToLowercase = function () {
                        // Function to convert init parameters to lowercase
                        var newParams = {}; // Object to hold new parameters
                        var keyLowerCase; // Variable for lowercase key
                        for (var key of Object.keys(_initParams)) {
                            // Iterate through initParams
                            keyLowerCase = key.toLowerCase(); // Convert key to lowercase
                            newParams[keyLowerCase] = _initParams[key]; // Assign value to new parameters
                        }
                        _initParams = newParams; // Update init parameters
                    };
                    var convertInitParamsToStrings = function () {
                        // Function to convert init parameters to strings
                        for (var key of Object.keys(_initParams)) {
                            // Iterate through initParams
                            if (
                                _initParams[key] &&
                                typeof _initParams[key] === 'object' // Check if value is an object
                            ) {
                                if (Array.isArray(_initParams[key])) {
                                    // Check if value is an array
                                    _initParams[key] = _initParams[key].join(','); // Convert array to string
                                } else {
                                    _initParams[key] = JSON.stringify(
                                        _initParams[key], // Convert object to JSON string
                                    );
                                }
                            }
                        }
                    };
                    var setParams = function (_params, extendedParams) {
                        // Function to set parameters
                        var paramsKeys = Object.keys(_params); // Get keys of parameters
                        for (var i = 0; i < paramsKeys.length; i++) {
                            // Iterate through parameter keys
                            var key = paramsKeys[i]; // Get parameter key
                            this.setParam(key, _params[key], extendedParams); // Set parameter
                        }
                    };
                    var setParam = function (param, value, extendedParams) {
                        // Function to set a single parameter
                        var paramInLowerCase = param.toLowerCase(); // Convert parameter to lowercase
                        _initParams[paramInLowerCase] = value; // Assign value to initParams
                        prepareInitParams(); // Prepare initialization parameters
                        var triggerCallback = extendedParams && extendedParams.triggerCallback; // Check if callback should be triggered
                        if (triggerCallback === false) {
                            // If callback should not be triggered
                            triggerStateChangeCallback = triggerCallback; // Set flag
                        }
                        if (postloadParams.hasParam(paramInLowerCase)) {
                            // Check if parameter exists in postloadParams
                            postloadParams.sendIFrameMessage(); // Send message to iframe
                        } else if (
                            dimensionsParams.hasParam(paramInLowerCase) // Check if parameter exists in dimensionsParams
                        ) {
                            dimensionsParams.sendIFrameMessage(); // Send message to iframe
                        } else {
                            setIframeSrc(); // Set iframe source
                        }
                    };
                    var destroy = function () {
                        // Function to destroy the instance
                        window.removeEventListener('hashchange', setIframeSrc); // Remove hash change event listener
                        window.removeEventListener('message', onIframeMessage); // Remove message event listener
                        window.removeEventListener('scroll', onWindowScroll); // Remove scroll event listener
                        window.removeEventListener('resize', onWindowResize); // Remove resize event listener
                        if (iframe && iframe.parentNode) {
                            // Check if iframe exists and has a parent
                            iframe.parentNode.removeChild(iframe); // Remove iframe from DOM
                            iframe = null; // Set iframe to null
                        }
                    };
                    var logout = function () {
                        // Function to log out
                        _initParams.token = ''; // Clear token
                        _initParams.accesstoken = ''; // Clear access token
                        setIframeSrc(); // Set iframe source
                    };
                    var getParams = function () {
                        // Function to get parameters
                        var getMatchedParams = function (params) {
                            // Function to get matched parameters
                            var matchedParams = []; // Array to hold matched parameters
                            for (var key of Object.keys(params)) {
                                // Iterate through parameters
                                if (
                                    internalParams.indexOf(params[key]) === -1 // Check if parameter is not internal
                                ) {
                                    matchedParams.push(params[key]); // Add to matched parameters
                                }
                            }
                            return matchedParams; // Return matched parameters
                        };
                        var internalParams = [
                            // List of internal parameters
                            'accesstoken',
                            'ishybridmode',
                            'staticorigin',
                            'instance',
                            'hasplacebetplatformerrorcallback',
                            'oddstype',
                            'special',
                            'ishashclassesmode',
                        ];
                        var params = getMatchedParams(queryParams.params).concat(getMatchedParams(hashParams.params)); // Get matched parameters from query and hash
                        return params; // Return parameters
                    };
                    var container = document.querySelector(_containerId); // Select container element
                    if (
                        container &&
                        container.tagName.toLowerCase() === 'iframe' // Check if container is an iframe
                    ) {
                        var nextSibling = container.nextSibling; // Get next sibling of container
                        var parentNode = container.parentNode; // Get parent node of container
                        extendInitParamsWithSRC(container.attributes.src.value); // Extend init parameters with iframe source
                        var newContainer = document.createElement('div'); // Create new div container
                        newContainer.className = container.className; // Set class name
                        newContainer.id = container.id; // Set ID
                        container.remove(); // Remove old container
                        parentNode.insertBefore(newContainer, nextSibling); // Insert new container before next sibling
                        container = newContainer; // Update container reference
                    }
                    prepareInitParams(); // Prepare initialization parameters
                    window.addEventListener('hashchange', setIframeSrc); // Add hash change event listener
                    window.addEventListener('message', onIframeMessage); // Add message event listener
                    window.addEventListener('scroll', onWindowScroll); // Add scroll event listener
                    window.addEventListener('resize', onWindowResize); // Add resize event listener
                    _initParams.token = _initParams.token || ''; // Initialize token
                    setIframeSrc(); // Set iframe source
                    _initParams.token = null; // Clear token
                    iframe.style.border = '0px'; // Set iframe border style
                    iframe.style.width = '1px'; // Set iframe width
                    iframe.style.minWidth = '100%'; // Set minimum width
                    iframe.style.minHeight = '100vh'; // Set minimum height
                    iframe.scrolling = (_initParams.isfixed && 'yes') || 'no'; // Set scrolling attribute
                    this.error = ''; // Initialize error message
                    if (container) {
                        // Check if container exists
                        container.appendChild(iframe); // Append iframe to container
                        this.iframe = iframe; // Store iframe reference
                        this.setParam = setParam; // Assign setParam method
                        this.setParams = setParams; // Assign setParams method
                        this.getParams = getParams; // Assign getParams method
                        this.destroy = destroy; // Assign destroy method
                        this.logout = logout; // Assign logout method
                    } else {
                        this.error = 'container not found'; // Set error message if container not found
                        console.warn(this.error); // Log warning
                    }
                };
                if (!window.AltenarSportsbook2) {
                    // Check if AltenarSportsbook2 is not defined
                    AltenarSportsbook2.version = '2.557.0' + this.buildVersion; // Set version
                    window.AltenarSportsbook2 = AltenarSportsbook2; // Assign to global window object
                }
            })();
            var options = {
                // Options for AltenarSportsbook2 instance
                token: profile.TokenSportsbook, // Set token from profile
                skinid: skinIdITN, // Set skin ID
                walletcode: profile.walletcodeSportbookITN, // Set wallet code
                full: true, // Set full option
                page: 'mybets', // Set page option
                lang: lng, // Set language option
                fixed: false, // Set fixed option
            };
            var BIA = new AltenarSportsbook2('#BIA_client_container', options); // Create new instance of AltenarSportsbook2
        });
        return {
            // Return configuration for the view
            view: 'template', // Set view type to template
            template: "<div id='BIA_client_container' style='overflow: scroll; height: 100%; width: 100%;'></div>", // Set template HTML
        };
    }
}

// FILE DOCUMENTED
